// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1YGQw","col":"CardReaderDesc_col__1sTKK","label":"CardReaderDesc_label__2d_mD"};